import { select } from 'd3';
import { Entidad } from "../../../../data/Entidad";
import { _SvAlumnoEdoCtaNuevoPagoMultiple } from '../../../../data/modulo/FinanzasEstadoCuenta';
import _L from "../../../../util/Labels";
import { Button } from "../../../controlD3/Button";
import { Fields, FormGenerator } from "../../../controlD3/Formulario";
import { _ModalToALongProccess } from "../../../controlD3/ModalThings/ModalToALongProccess";
import { NotificacionV2 } from "../../../controlD3/NotificacionV2";
import { SelectV2 } from "../../../controlD3/SelectV2";
import { Table } from "../../../controlD3/Tabla";
import { UIUtilFormat } from "../../../util/Format";
import { UIUtilGeneral } from "../../../util/Util";
import { UIUtilViewData } from "../../../util/ViewData";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";

import CTipoPago = Entidad.CTipoPago;

type IEscuela = Entidad.IEscuela
type IMetodoPago = Entidad.IFinanzaMetodoPago;
type IMovimiento = AlumnoEdoCtaUtil.IMovimientoTbl;


export interface AlumnoEdoCtaPagoFormConfig {
    OnClose: () => void
    Escuela: IEscuela
    PreSeleccionados: Entidad.IFinanzaMovimientoV2[]
    InfoGeneral: AlumnoEdoCtaUtil.ICurrentData
    OnAccept_SuccessPays: () => void
}

export function _OpenModal_ProcesoPago(config: AlumnoEdoCtaPagoFormConfig) {
    enum CTipoProcesoPago {
        PagoSaldoTotal = 1,
        PagoSaldoPeriodo = 2,
        PagoParcial = 3
    }
    type IBaseData = UIUtilViewData.IBaseData;
    type IItemCargoPago = {
        Cargo: IMovimiento;
        Pago: number;
    }
    type IDataForm = {
        TipoPago: CTipoProcesoPago;
        IdsCargosParciales: number[];
        CargosToPay: IItemCargoPago[];
        IdMetodoPago: number;
    }

    config.PreSeleccionados = (config.PreSeleccionados || [])
        .filter(d => AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0);

    const idEscuela = config.Escuela.IdKinder;
    const metodosPagoList = AlumnoEdoCtaUtil.GetMetodosPagoList(idEscuela);
    const info = config.InfoGeneral;
    const tipoPagosList = [
        { Id: CTipoProcesoPago.PagoSaldoTotal, Name: _L("panelfinanzasedocuenta.tag_paytotal") },
        { Id: CTipoProcesoPago.PagoSaldoPeriodo, Name: _L("panelfinanzasedocuenta.tag_payperiod") },
        { Id: CTipoProcesoPago.PagoParcial, Name: _L("panelfinanzasedocuenta.tag_paypartial") }
    ];

    if (metodosPagoList.length == 0) {
        NotificacionV2._Mostrar(
            _L("panelfinanzasedocuenta.notif_escsinmtdspago")
                .replace("_ESCUELA", config.Escuela?.Nombre),
            "ADVERTENCIA"
        );
        return;
    }

    const movimientosFaltoPagoList = info.MovimientosTbl_TopPeriodo
        .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

    const movimientosPeriodoFaltoPagoList = info.MovimientosPeriodo
        .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

    const fnUpdateProcesoPagoDataFromFormsData = () => {
        procesoPagoData.TipoPago = formTipoPago._Data.TipoPago;
        procesoPagoData.IdsCargosParciales = formTipoPago._Data.IdsCargosParciales;
        procesoPagoData.IdMetodoPago = formMetodoPago?._Data?.IdMetodoPago;
    }

    const procesoPagoData = <IDataForm>{
        TipoPago: (config.PreSeleccionados.length ? CTipoProcesoPago.PagoParcial : null),
        IdsCargosParciales: config.PreSeleccionados.map(d => d.Id),
    };

    let formTipoPago: FormGenerator<IDataForm>;
    let formMetodoPago: FormGenerator<IDataForm>;
    let ctrlTblPagosParciales: Table.Tabla<IItemCargoPago>;

    _ModalToALongProccess({
        Modulo: AlumnoEdoCtaUtil.MODULO_PERMISO,
        Action: Entidad.CAccionPermiso.RegistrarPagos,
        IdsEscuelas: [idEscuela],
        StartEndIds: ["pay_tipopago", "pay_mtdopago"],
        StepsConfig: [
            {
                // >> Step 1: Selecciona el tipo de pago. Cargos agrupados en:
                // * Pago del saldo total: todos los visibles en la tabla
                // * Pago del saldo del periodo: todos los del periodo filtrado
                // * Pago parcial: solo los que seleccione el usuario
                Id: "pay_tipopago",
                Title: "tag_paycharges",
                NextID: () => ((formTipoPago._Data.TipoPago == CTipoProcesoPago.PagoParcial) ? "pay_parcialpagos" : "pay_resumen"),
                Width: 420,
                OnDrawContent: (content, mt) => {
                    const fnUpdateFormTipoPago = (idTipoPago: CTipoProcesoPago, expandChargesList: boolean = false) => {
                        const esPagoParcial = (idTipoPago == CTipoProcesoPago.PagoParcial);
                        const formRowCargosParciales = formTipoPago._ControlsData.get("IdsCargosParciales");

                        let selectPagosParciales = formTipoPago._ControlsData.get("IdsCargosParciales").selection;
                        selectPagosParciales.attr("required", esPagoParcial ? "" : null);

                        formRowCargosParciales.row
                            .classed("hide", !esPagoParcial);

                        if (!esPagoParcial) {
                            mt.BtnRight._Enable(!!idTipoPago);
                        } else if (expandChargesList) {
                            (formRowCargosParciales.instance as SelectV2)
                                ._ResetSelect()
                                ._showOptionsList();
                        }
                    }

                    formTipoPago = new FormGenerator<IDataForm>()
                        ._Crear({
                            LangModuleKeyInContext: AlumnoEdoCtaUtil.MODULO_LANG_KEY,
                            LabelMaxWidth: 125,
                            schema: [
                                {
                                    model: "TipoPago",
                                    labelAttr: { text: "tag_paytype" },
                                    type: Fields.selectMaterial,
                                    selectMaterialAttr: {
                                        required: true,
                                        valueMember: "Id",
                                        displayMember: "Name",
                                        onSelect: (dato: IBaseData) => {
                                            if (formTipoPago) {
                                                fnUpdateFormTipoPago(dato?.Id, true);
                                            }
                                        },
                                        // onChange: (id, dato: IBaseData) => {}
                                    },
                                    values: tipoPagosList
                                },
                                {
                                    model: "IdsCargosParciales",
                                    labelAttr: { text: "tag_chargestopay" },
                                    type: Fields.selectMaterial,
                                    selectMaterialAttr: {
                                        valueMember: "Id",
                                        displayMember: "Cargo",
                                        multiselect: true,
                                        required: false,
                                        onSelect: (datos: IMovimiento[]) => {
                                            mt.BtnRight._Enable(!!datos.length);
                                            // console.log(datos);
                                        },
                                        // onChange: (a: number, b: IMovimiento[]) => {}
                                        OnStepItemListUI: (container, data: IMovimiento, step) => {
                                            let one = container.select(".one");
                                            let two = container.select(".two");
                                            let three = container.select(".three");
                                            if (step == "enter") {
                                                container.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
                                                one = container.append("label").classed("one", true);
                                                two = container.append("label").classed("two", true);
                                                three = container.append("label").classed("three", true);
                                            }
                                            one.text(_L("panelfinanzasedocuenta.tag_period") + ": " + data.Periodo);
                                            two.text(_L("panelfinanzasedocuenta.tag_descript") + ": " + data.Cargo);
                                            three.text(_L("panelfinanzasedocuenta.d_field_saldo") + ": " + UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(data)));
                                        },
                                        OnChangeSearchText_GetDataValueToEval: (dato: IMovimiento) => `${dato.Periodo} ${dato.Cargo} ${UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(dato))}`,
                                        ShowAndEnableSearchText: true,
                                        ShowNSelectedInList: true
                                    },
                                    values: movimientosFaltoPagoList
                                }
                            ],
                            // Validation: (val, field) => {
                            //     if (field == "TipoPago") {
                            //         return Boolean(val);
                            //     }
                            //     return true;
                            // }
                        }, procesoPagoData);


                    // Deshabilita tipo de pago para el total del periodo, si no hay datos que cargos que pagar
                    if (!movimientosPeriodoFaltoPagoList.length) {
                        (formTipoPago._ControlsData.get("TipoPago").instance as SelectV2)
                            ._disableItems(CTipoProcesoPago.PagoSaldoPeriodo);
                    }

                    // Inicializa vista del frm
                    if (config.PreSeleccionados.length) {
                        fnUpdateFormTipoPago(procesoPagoData.TipoPago, false);
                    } else {
                        fnUpdateFormTipoPago(null);
                    }

                    content.append(() => formTipoPago._Form.node());
                },
                OnValideStep: () => {
                    const formIsValid = formTipoPago._GetIsValidForm();

                    if (formIsValid) {
                        fnUpdateProcesoPagoDataFromFormsData();

                        // Ajusta los cargos a pagar antes de pasar a la vista siguiente
                        procesoPagoData.CargosToPay = [];

                        switch (formTipoPago._Data.TipoPago) {
                            case CTipoProcesoPago.PagoSaldoTotal:
                                procesoPagoData.CargosToPay = movimientosFaltoPagoList
                                    .map<IItemCargoPago>(d => ({
                                        Cargo: d,
                                        Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                                    }))
                                break;
                            case CTipoProcesoPago.PagoSaldoPeriodo:
                                procesoPagoData.CargosToPay = movimientosPeriodoFaltoPagoList
                                    .map<IItemCargoPago>(d => ({
                                        Cargo: d,
                                        Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                                    }));
                                break;
                            case CTipoProcesoPago.PagoParcial:
                                const ctrlSelectCargos = (formTipoPago._ControlsData.get("IdsCargosParciales").instance as unknown as SelectV2<IMovimiento, "Id", "multiselect">);

                                procesoPagoData.CargosToPay = ctrlSelectCargos._dataSelected
                                    .map(d => ({
                                        Cargo: d,
                                        Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                                    }))
                                break;
                        }
                        console.warn("-d", "procesoPagoData", procesoPagoData);
                        return Boolean(procesoPagoData.CargosToPay.length);
                    }

                    return false;
                }
            },
            {
                // >> Step 1.1: Solo cuando el tipo de pago sea Parcial
                Id: "pay_parcialpagos",
                Title: "tag_payselchargs",
                PreviousID: "pay_tipopago",
                NextID: "pay_resumen",
                Width: 650,
                OnDrawContent: (content, mt) => {
                    content
                        .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
                        .style("row-gap", "10px")
                        .append("label")
                        .text(_L("panelfinanzasedocuenta.tag_confirmpays"));

                    const fnValidaInputPagoUI = (itemPago: IItemCargoPago, inputBox: TSelectionHTML<"div">, cellContent: TSelectionHTML<"div">) => {
                        let resValidation = AlumnoEdoCtaUtil.GetPagoValidation(itemPago.Pago, itemPago.Cargo);

                        // inputBox.classed("input_err", !resValidation.IsValid);

                        if (resValidation.IsValid) {
                            cellContent.select(".lbl_error").remove();
                            // mt.Notificator.fn_Mostrar(resValidation.Message, "ADVERTENCIA");
                        } else {
                            let lblError = cellContent.select(".lbl_error");

                            if (!lblError.node()) {
                                lblError = cellContent.append("label")
                                    .attr("class", "lbl_error")
                                    .style("color", "red")
                                    .style("cursor", "pointer")
                                    .style("font-size", "calc(var(--fontsize_me4) - 2px)");
                            }

                            lblError
                                .on("click", () => {
                                    let pagoEsperadoFixer: number;

                                    if (resValidation.TypeFix == "minrecargo") {
                                        pagoEsperadoFixer = AlumnoEdoCtaUtil.GetAdeudoRecargoFromCargo(itemPago.Cargo);
                                    } else {
                                        pagoEsperadoFixer = AlumnoEdoCtaUtil.GetSaldoMovimiento(itemPago.Cargo);
                                    }

                                    itemPago.Pago = pagoEsperadoFixer;
                                    inputBox.select("input")
                                        .property("value", pagoEsperadoFixer);

                                    fnValidaInputPagoUI(itemPago, inputBox, cellContent);
                                })
                                .text(resValidation.Message);
                        }
                    }

                    ctrlTblPagosParciales = new Table.Tabla<IItemCargoPago>({
                        IdTabla: "AlumnosPanelEstadoCuenta-PayPagosParciales",
                        Parent: content,
                        IdData: "" as any,
                        MinWidth: 580,
                        HideCheckboxes: true,
                        Resizable: false,
                        RenderColumnHeadings: [
                            { Field: "Periodo" as any, Label: _L("panelfinanzasedocuenta.tag_perioddesc"), IsSortable: false, MinWidth: "120px", Width: "50%" },
                            { Field: "Saldo" as any, Label: _L("panelfinanzasedocuenta.tag_debe"), IsSortable: false, MinWidth: "90px", Width: "25%" },
                            { Field: "Pago" as any, Label: _L("panelfinanzasedocuenta.tag_montopay"), IsSortable: false, MinWidth: "90px", Width: "25%" },
                        ],
                        OnValueSelectRow: (id, datum) => {
                            console.log(id, datum);
                        },
                        EvaluatorAndSubLevelsBuild: {
                            OnStepRowTable: (itemCargo, tr) => {
                                tr
                                    .classed("cargo_" + itemCargo.Cargo.Id, true)
                                    .style("border-bottom", "none");
                            },
                            OnStepCellTable: (container, datum, field) => {
                                let saldo = AlumnoEdoCtaUtil.GetSaldoMovimiento(datum.Cargo);

                                switch (field) {
                                    case "Periodo":
                                        container.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
                                        container.html(`
                                                            <span id="periodo">${_L("panelfinanzasedocuenta.tag_period")}: ${datum.Cargo.Periodo}</span>
                                                            <span id="descripcion">${_L("panelfinanzasedocuenta.tag_descript")}: ${datum.Cargo.Cargo}</span>
                                                        `);
                                        break;
                                    case "Saldo":
                                        container.text(UIUtilFormat._CurrencyFmt(saldo))
                                        break;
                                    case "Pago":
                                        let inputC = container.select<HTMLDivElement>(".input_content");

                                        if (!inputC.node()) {
                                            inputC = container
                                                .style("width", "100%")
                                                .html(`<div class="input_content input_currency"></div>`)
                                                .select<HTMLDivElement>(".input_content")
                                                .style("position", "relative");

                                            inputC.append<HTMLInputElement>("input")
                                                .attr("type", "number")
                                                .attr("step", ".01");
                                            inputC.append("div")
                                                .attr("class", "input_symbol")
                                                .append("span")
                                                .text("$");
                                        }
                                        inputC.select<HTMLInputElement>("input")
                                            .attr("min", AlumnoEdoCtaUtil.GetAdeudoRecargoFromCargo(datum.Cargo))
                                            .attr("max", saldo)
                                            .property("value", datum.Pago)
                                            .node()
                                            .onchange = (e) => {
                                                datum.Pago = select(e.target as HTMLInputElement).node().valueAsNumber;

                                                if (isNaN(datum.Pago)) {
                                                    datum.Pago = 0;
                                                    (e.target as HTMLInputElement).value = "0";
                                                }

                                                fnValidaInputPagoUI(datum, inputC, container);
                                            };

                                        fnValidaInputPagoUI(datum, inputC, container);
                                        break;
                                    // return false;
                                }
                            }
                        }
                        // OnStepDelayedItemRowTableV2: (rowBody, tr) => {return true;},
                        // OnStepItemTableV2: (container, datum, field, index) => {}
                    });
                },
                OnFocusContent: (content, mt) => {
                    ctrlTblPagosParciales._UpdateData(procesoPagoData.CargosToPay);
                },
                OnValideStep: (content, mt) => {
                    let isValid = true;
                    let message: string;

                    for (let cargoAPagar of procesoPagoData.CargosToPay) {
                        let resValidation = AlumnoEdoCtaUtil.GetPagoValidation(cargoAPagar.Pago, cargoAPagar.Cargo);

                        if (!resValidation.IsValid) {
                            isValid = resValidation.IsValid;
                            message = resValidation.Message;

                            ctrlTblPagosParciales._Control
                                .select(".rbodyB")
                                .select<HTMLTableRowElement>(".cargo_" + cargoAPagar.Cargo.Id)
                                .node()
                                ?.scrollIntoView({
                                    block: "center",
                                    behavior: "smooth"
                                });
                            break;
                        }
                    }

                    return {
                        IsValid: isValid,
                        Message: message
                    }
                }
            },
            {
                // >> Step 2: Resumen del pago a aplicar
                Id: "pay_resumen",
                Title: "", // "tag_resum",
                PreviousID: () => ((formTipoPago._Data.TipoPago == CTipoProcesoPago.PagoParcial) ? "pay_parcialpagos" : "pay_tipopago"),
                NextID: "pay_mtdopago",
                Width: 560,
                OnDrawContent: (content, mt) => {
                    content.classed("body_pagodos_info", true);
                },
                OnFocusContent: (content, mt) => {
                    mt.Modal._SetTitle(`${_L("panelfinanzasedocuenta.tag_resum")} - ${tipoPagosList.find(d => (d.Id == formTipoPago._Data.TipoPago)).Name}`);
                    Button._EnableButton(mt.BtnRight, true);

                    const fnBuildResumenContent = (body: d3.Selection<HTMLDivElement, any, any, any>, cargosToPay: IItemCargoPago[], description?: string) => {
                        body.html(`
                            <label class="description ${(!description ? "hide" : "")}">${description}</label>
                            <div class="list ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                <div class="cargos_header">
                                    <div class="item_row">
                                        <label class="desc">${_L("panelfinanzasedocuenta.tag_cargo")}</label>
                                        <label class="debe">${_L("panelfinanzasedocuenta.tag_debe")}</label>
                                        <label class="pago">${_L("panelfinanzasedocuenta.tag_pago")}</label>
                                    </div>
                                </div>
                                <div class="cargos ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                    <div class="item_row">
                                        <div class="desc"></div>
                                        <div class="debe"></div>
                                        <div class="pago"></div>
                                    </div>
                                </div>
                                <div class="totales ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                    <div class="item_row">
                                        <label class="desc"></label>
                                        <label class="debe"></label>
                                        <label class="pago"></label>
                                    </div>
                                </div>
                            </div>
                        `);

                        body.select<HTMLDivElement>(".cargos").selectAll<HTMLDivElement, IItemCargoPago>(".item_row").data(cargosToPay).join(
                            enter => {
                                let itemRow = enter.append("div")
                                    .attr("class", "item_row");

                                itemRow.append("div").attr("class", "desc")
                                    .html(d => `
                                        <label>${_L("panelfinanzasedocuenta.tag_period")}: ${d.Cargo.Periodo}</label>
                                        <label>${_L("panelfinanzasedocuenta.tag_descript")}: ${d.Cargo.Cargo}</label>
                                    `);
                                itemRow.append("div").attr("class", "debe").text(d => UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(d.Cargo)));
                                itemRow.append("div").attr("class", "pago").text(d => UIUtilFormat._CurrencyFmt(d.Pago));
                                return itemRow;
                            },
                            update => {
                                update.select(".desc").html(d => `
                                                    <label>${_L("panelfinanzasedocuenta.tag_period")}: ${d.Cargo.Periodo}</label>
                                                    <label>${_L("panelfinanzasedocuenta.tag_descript")}: ${d.Cargo.Cargo}</label>
                                                `)
                                update.select(".debe").text(d => UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(d.Cargo)));
                                update.select(".pago").text(d => UIUtilFormat._CurrencyFmt(d.Pago));
                                return update;
                            },
                            exit => exit.remove()
                        );
                    }


                    let totalPago = 0;
                    let deudaInicial = 0;

                    procesoPagoData.CargosToPay
                        .forEach(d => {
                            deudaInicial += AlumnoEdoCtaUtil.GetSaldoMovimiento(d.Cargo);
                            totalPago += d.Pago;
                        });

                    switch (procesoPagoData.TipoPago) {
                        case CTipoProcesoPago.PagoSaldoTotal:
                        case CTipoProcesoPago.PagoSaldoPeriodo:
                            let strDescription = ""

                            if (procesoPagoData.TipoPago == CTipoProcesoPago.PagoSaldoTotal) {
                                strDescription = _L("panelfinanzasedocuenta.tag_paysaldoacumperiodo");
                            } else {
                                strDescription = _L("panelfinanzasedocuenta.tag_paysaldoperiodo");
                            }

                            fnBuildResumenContent(content, procesoPagoData.CargosToPay, (strDescription + ": " + info.StrPeriodo));

                            content.select<HTMLDivElement>(".totales")
                                .html(`
                                    <div class="item_row">
                                        <label class="desc">${_L("panelfinanzasedocuenta.infocta_totpagar")}:</label>
                                        <label class="debe"></label>
                                        <label class="pago sometotal">${UIUtilFormat._CurrencyFmt(totalPago)}</label>
                                    </div>
                                `);
                            break;
                        case CTipoProcesoPago.PagoParcial:
                            fnBuildResumenContent(content, procesoPagoData.CargosToPay);

                            content.select<HTMLDivElement>(".totales")
                                .html(`
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.infocta_totpagar")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago">${UIUtilFormat._CurrencyFmt(totalPago)}</label>
                                </div>
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.tag_deudainit")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago">${UIUtilFormat._CurrencyFmt(deudaInicial)}</label>
                                </div>
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.tag_deudaresta")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago sometotal">${UIUtilFormat._CurrencyFmt(deudaInicial - totalPago)}</label>
                                </div>
                            `);
                            break;
                    }
                }
            },
            {
                // >> Step 3: Selección del método de pago (último paso)
                Id: "pay_mtdopago",
                Title: "tag_paymtd",
                PreviousID: "pay_resumen",
                Width: 400,
                OnDrawContent: (content, mt) => {
                    formMetodoPago = new FormGenerator<IDataForm>()
                        ._Crear({
                            LangModuleKeyInContext: AlumnoEdoCtaUtil.MODULO_LANG_KEY,
                            LabelMaxWidth: 140,
                            schema: [
                                {
                                    model: "IdMetodoPago",
                                    type: Fields.selectMaterial,
                                    labelAttr: { text: "tag_paymtd" },
                                    selectMaterialAttr: {
                                        valueMember: "IdMetodoPago",
                                        displayMember: "Nombre",
                                        onSelect: (datoMP: IMetodoPago) => {
                                            Button._EnableButton(mt.BtnRight, Boolean(datoMP));
                                        }
                                    },
                                    values: metodosPagoList
                                }
                            ],
                            Validation: (val) => Boolean(val)
                        }, procesoPagoData);

                    content.append(() => formMetodoPago._Form.node());
                },
                OnFocusContent: (content, mt) => {
                    if (formMetodoPago?._Data.IdMetodoPago) return;
                    setTimeout(() => {
                        (formMetodoPago._ControlsData.get("IdMetodoPago").instance as SelectV2)._showOptionsList();
                    }, 200);
                },
                OnValideStep: () => formMetodoPago._GetIsValidForm(),
                OnAccept: async (mt) => {
                    fnUpdateProcesoPagoDataFromFormsData();
                    // console.warn(procesoPagoData);
                    const res = await Sv_RegistrarPagosMultiple(procesoPagoData.IdMetodoPago, procesoPagoData.CargosToPay);
                    const someCargosPagados = [-2, -3].includes(res.Resultado);
                    if (res.Resultado > 0 || someCargosPagados) {

                        config.OnAccept_SuccessPays()

                        if (someCargosPagados) {
                            mt.Modal._Ocultar();
                        }
                    }
                    return res;
                }
            }
        ],
        OnClose: () => {
            config.OnClose();
        }
    });


    function Sv_RegistrarPagosMultiple(idMetodoPago: number, cargosToPay: { Cargo: IMovimiento, Pago: number }[]) {
        return _SvAlumnoEdoCtaNuevoPagoMultiple(
            idMetodoPago,
            cargosToPay.map(d => {
                return {
                    Id: d.Cargo.Id,
                    Monto: d.Pago,
                    TipoPago: ((d.Pago == AlumnoEdoCtaUtil.GetSaldoMovimiento(d.Cargo)) ? CTipoPago.PagoCompleto : CTipoPago.PagoParcial)
                }
            })
        );
    }
}